<template>
  <div class="address-book">
    <h1 class="mb-4">Address Book</h1>
    <div class="bg-white table-shadow p-4 mb-4">
      <CustomerSelect :create-customer-allowed="false" @selected="handleSelect" />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { useRouter } from 'vue-router'
import { STAFF_ADDRESS_BOOK_COMPANY } from '@/types/router'
import CustomerSelect from '@/views/Components/Customer/CustomerSelect.vue'

export default defineComponent({
  name: 'AddressBookSelectPage',
  components: { CustomerSelect },
  setup() {
    const router = useRouter()

    const handleSelect = (id: string) => {
      router.push({
        name: STAFF_ADDRESS_BOOK_COMPANY,
        params: { companyId: id },
      })
    }

    return { handleSelect }
  },
})
</script>
